import { HeaderWrap, LeftContent, CenterContent, RightContent } from './styles';
import Hamburger from './hamburger';
import FullScreenButton from './fullScreenButton';
import AvatarMenu from './avatarMenu';
// import ToogleTheme from './toogleTheme';
const Header = () => {
	return (
		<HeaderWrap>
			<LeftContent>
				<Hamburger />
			</LeftContent>
			<CenterContent>KERALAZZIO</CenterContent>
			<RightContent>
				{/* <ToogleTheme /> */}
				<FullScreenButton />
				<AvatarMenu />
			</RightContent>
		</HeaderWrap>
	);
};
export default Header;
